import { render } from "./my-grid.vue?vue&type=template&id=d7223134&ts=true"
import script from "./my-grid.vue?vue&type=script&lang=ts"
export * from "./my-grid.vue?vue&type=script&lang=ts"

import "./my-grid.vue?vue&type=style&index=0&id=d7223134&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__